export const SITE_PAGE_DEFINITIONS = [
  {
    key: 'transfer',
    label: '商标转让流程',
    path: '/transfer',
    layout: 'banner'
  },
  { key: 'about', label: '关于我们', path: '/about', layout: 'card' },
  { key: 'contact', label: '联系我们', path: '/contact', layout: 'card' },
  { key: 'help', label: '帮助中心', path: '/help', layout: 'card' },
  {
    key: 'qualification',
    label: '公司资质',
    path: '/qualification',
    layout: 'card'
  },
  { key: 'privacy', label: '隐私政策', path: '/privacy', layout: 'card' }
]

export function findSitePageDefinition(key) {
  return SITE_PAGE_DEFINITIONS.find(item => item.key === key) || null
}
